import { getDynamicCameraOptions, getFriendlyDateLabel } from "../../utils/utils-file";

export default function CameraSelect({ value, onChange }) {
  const dynamicOptions = getDynamicCameraOptions();
  
  return (
    <section className="camera-select-wrapper">
      <label className="camera-select-label">Camera/Location</label>
      <select
        className="camera-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {dynamicOptions.map((opt) => (
          <option key={opt} value={opt}>
            {getFriendlyDateLabel(opt)}
          </option>
        ))}
      </select>
    </section>
  );
}
